import {selectFilter} from "@/components/forms/renderers/filters/SelectFilter";
import {checkboxFilter} from "@/components/forms/renderers/filters/ChechboxFilter";
import {dateFilter} from "@/components/forms/renderers/filters/DateFilter";
import {numericFilter} from "@/components/forms/renderers/filters/NumericFilter";

// #column-filters
const FILTER_SELECT = "FILTER_SELECT";
const FILTER_CHECKBOX = "FILTER_CHECKBOX";
const FILTER_DATE = "FILTER_DATE";
const FILTER_NUMERIC = "FILTER_NUMERIC";

const filterRenderers = {
    FILTER_SELECT: selectFilter,
    FILTER_CHECKBOX: checkboxFilter,
    FILTER_DATE: dateFilter,
    FILTER_NUMERIC: numericFilter
}

export default filterRenderers;

